import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import {  useSelector } from 'react-redux';
import { useGetProfileQuery } from '../slices/students/studentsApiSlice';
import { LinkContainer } from 'react-router-bootstrap';

const SubscriptionPlan = ({ plan, isoneactive, isonestrill, ispaastdue, subjectData }) => {

    const { id } = useParams();

    const { studentInfo } = useSelector((state) => state.authStudent);

    return (
        <div className={`card card-pricing bg-gradient-${plan.color} shadow-lg rounded border-0 text-center mb-4 subCard2 ` }>
            <div className="card-header bg-transparent">
                <h4 className="text-uppercase ls-1 text-white py-3 mb-0">Learning Plan</h4>
            </div>
            <div className="card-body px-lg-5">
                <div className="display-4 text-white">
                    <span className="priceP2">${plan.price}</span>
                    </div>
                <span className="text-white">monthly

                </span>
                <ul className="list-unstyled my-4">
                    <li>
                        <div className="d-flex align-items-center publicPItem2">
                        <div>
                            <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                            <i className="fas fa-check"></i>
                            </div>
                        </div>
                        <div>
                            <span className="pl-1 text-white">  &nbsp;You can ask up to {plan.totalQuestions} 
                                <br /> &nbsp; &nbsp; monthly questions </span>
                        </div>
                        </div>
                    </li><br />
                    { subjectData?.isCoursePublish ?
                    <li>
                        <div className="d-flex align-items-center publicPItem2">
                        <div>
                            <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                            <i className="fas fa-check"></i>
                            </div>
                        </div>
                        <div>
                            {/* <span className="pl-2 text-white">Each Question can <br /> &nbsp; &nbsp; last up to 5 minutes</span> */}
                            <span className="pl-2 text-white"> &nbsp; {subjectData?.tittle}  <br /> online course </span>

                        </div>
                        </div>
                    </li>
                    :
                    <li>
                        <div className="d-flex align-items-center publicPItem2">
                        <div>
                            <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                            <i className="fas fa-check"></i>
                            </div>
                        </div>
                        <div>
                            <span className="pl-2 text-white">Each Question can <br /> &nbsp; &nbsp; last up to 5 minutes</span>
                        </div>
                        </div>
                    </li>
                    }
                    <li><br />
                        <div className="d-flex align-items-center publicPItem2">
                        <div>
                            <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                            <i className="fas fa-check"></i>
                            </div>
                        </div>
                        <div>
                            <span className="pl-2 text-white">
                            Record your screen or <br />
                            &nbsp;   camera to ask  questions
                            </span>
                        </div>
                        </div>
                    </li>
                </ul>
                <div className='cardw2'>
                { (plan.renewal && plan.pastDue == false) ?
                    <LinkContainer to={`/studentcancelsubscription/${plan._id}`} className=''>
                        <button type="button" className={`btn btn-white text-white mb-3`}>Cancel</button>
                    </LinkContainer >
                    :
                     plan.active ? 
                        (isoneactive && plan.pastDue == false) ||  (isonestrill && plan.pastDue == false) ?
                        <LinkContainer to={`/studentsupgradesubscription/${plan._id}`} className=''>
                            <button type="button" className={`btn btn-white  text-white mb-3`}>Subscribe</button>
                        </LinkContainer >
                        : 
                        plan.pastDue == true ?
                        <LinkContainer to={`/studentsupgradesubscription/${plan._id}`} className=''>
                            <button type="button" className={`btn btn-white  text-white mb-3`}>Make Payment</button>
                        </LinkContainer >                            
                        :                      
                        <LinkContainer to={`/studentsubscribe/${plan._id}`} className=''>
                            <button type="button" className={`btn btn-white  text-white mb-3`}>Subscribe</button>
                        </LinkContainer >                           
                    :     
                    <button type="button" className={`btn btn-white text-white mb-3`}>Inactive</button>
                }     
            </div>            
            </div>
            {/* <div className="card-footer bg-transparent card-footer2">
            </div> */}
        </div>    
      )
    }



export default SubscriptionPlan
